export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5199.3f7c5d0d.jpg";